import React from 'react'

export const HowWorksIt = () => {
    return (
        <>
            <section className="fullwidth padding-top-75 padding-bottom-70" data-background-color="#f9f9f9">
                <div className="container">

                    <div className="row">
                        <div className="col-md-8 col-md-offset-2">
                            <h3 className="headline centered headline-extra-spacing">
                                <strong className="headline-with-separator">Plan The Vacation of Your Dreams</strong>
                                <span className="margin-top-25">Explore some of the best tips from around the world from our partners and friends. Discover some of the most popular listings!</span>
                            </h3>
                        </div>
                    </div>

                    <div className="row icons-container">
                        <div className="col-md-4">
                            <div className="icon-box-2 with-line">
                                <i className="im im-icon-Map2"></i>
                                <h3>Find Interesting Place</h3>
                                <p>Proin dapibus nisl ornare diam varius tempus. Aenean a quam luctus, finibus tellus ut, convallis eros sollicitudin.</p>
                            </div>
                        </div>

                        <div className="col-md-4">
                            <div className="icon-box-2 with-line">
                                <i className="im im-icon-Mail-withAtSign"></i>
                                <h3>Contact a Few Owners</h3>
                                <p>Maecenas pulvinar, risus in facilisis dignissim, quam nisi hendrerit nulla, id vestibulum metus nullam viverra purus.</p>
                            </div>
                        </div>

                        <div className="col-md-4">
                            <div className="icon-box-2">
                                <i className="im im-icon-Checked-User"></i>
                                <h3>Make a Reservation</h3>
                                <p>Faucibus ante, in porttitor tellus blandit et. Phasellus tincidunt metus lectus sollicitudin feugiat consectetur.</p>
                            </div>
                        </div>
                    </div>

                </div>
            </section>
        </>
    )
}
